var map = {
	"./images/node-js.png": 617
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1482;


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations ^.*\/node\-js\.png$
// module id = 1482
// module chunks = 147